import Button from "Components/Global/Buttons";
import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const ProjectModal = ({
  modalOpen,
  setModalOpen,
  title,
  onSubmit,
  children,
  showButtons = true,
}) => {
  const theme = useTheme();

  return (
    <>
      {modalOpen && (
        <S.ModalWrapper>
          <S.Modal>
            <S.ModalHeader>
              {title}
              <GetIcon
                name="X"
                onClick={() => setModalOpen(null)}
                color={theme.colors.neutral.white}
              />
            </S.ModalHeader>

            {children}

            {showButtons && (
              <S.ModalButtons>
                <Button
                  type="button"
                  outline
                  text="Cancelar"
                  onClick={() => setModalOpen(null)}
                />
                <Button
                  type="button"
                  text="Enviar"
                  onClick={() => onSubmit()}
                />
              </S.ModalButtons>
            )}
          </S.Modal>
        </S.ModalWrapper>
      )}
    </>
  );
};

export default ProjectModal;
